import { APP_INITIALIZER, inject, Provider } from '@angular/core';

import { PosthogService } from './posthog.service';

export function providePosthog(key: string | undefined): Provider[] {
  return key
    ? [
      {
        multi: true,
        provide: APP_INITIALIZER,
        useFactory: () => {
          const posthogService = inject(PosthogService);

          return () => posthogService.initialize(key);
        },
      },
    ]
    : [];
}
